module.exports = __webpack_public_path__ + "img/guide5.08d21cbe.jpg";